import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";

export function PinnedMessagesList({ chatId, pinnedIds, onUnpin }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (pinnedIds.length === 0) { setItems([]); return; }
    api.get(`/chats/${chatId}/pinned-messages`).then(({ data }) => setItems(data.messages || []));
  }, [chatId, pinnedIds]);
  if (pinnedIds.length === 0) {
    return (
      <div className="text-xs text-neutral-500 italic">
        Tap the pin button on any message to remember it forever (max 10). The bot will always remember pinned facts.
      </div>
    );
  }
  return (
    <ul className="space-y-1.5 mb-1" data-testid="pinned-messages-list">
      <div className="mb-1 text-[10px] uppercase tracking-widest text-neutral-500">Pinned messages ({pinnedIds.length}/10)</div>
      {items.map((m) => (
        <li key={m.id} className="flex items-start gap-2 rounded-lg bg-yellow-500/5 border border-yellow-500/20 p-2 text-xs text-neutral-200">
          <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-yellow-400" />
          <span className="flex-1">
            <span className="text-[10px] uppercase tracking-widest text-yellow-300/80 mr-1">{m.role === "user" ? "You" : "Bot"}:</span>
            {(m.content || "").slice(0, 220)}{(m.content || "").length > 220 ? "…" : ""}
          </span>
          <button
            onClick={() => onUnpin(m.id)}
            data-testid={`unpin-msg-${m.id}`}
            className="text-neutral-500 hover:text-white"
            aria-label="Unpin"
          >
            <X size={13} />
          </button>
        </li>
      ))}
    </ul>
  );
}
